import { render, staticRenderFns } from "./ModalMostrarPagoUniversidadAgrupados.vue?vue&type=template&id=c672711c&scoped=true"
import script from "./ModalMostrarPagoUniversidadAgrupados.vue?vue&type=script&lang=js"
export * from "./ModalMostrarPagoUniversidadAgrupados.vue?vue&type=script&lang=js"
import style0 from "./ModalMostrarPagoUniversidadAgrupados.vue?vue&type=style&index=0&id=c672711c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c672711c",
  null
  
)

export default component.exports